"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidScheme = exports.isResponseObject = exports.isTagObject = exports.isSecurityScheme = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../utils");
function isSecurityScheme(maybeSecurityScheme) {
    return utils_1.isDictionary(maybeSecurityScheme) && typeof maybeSecurityScheme.type === 'string';
}
exports.isSecurityScheme = isSecurityScheme;
exports.isTagObject = (maybeTagObject) => {
    if (lodash_1.isObject(maybeTagObject) && 'name' in maybeTagObject) {
        return typeof maybeTagObject.name === 'string';
    }
    return false;
};
exports.isResponseObject = (maybeResponseObject) => lodash_1.isObject(maybeResponseObject) &&
    ('description' in maybeResponseObject ||
        'schema' in maybeResponseObject ||
        'headers' in maybeResponseObject ||
        'examples' in maybeResponseObject);
function isValidScheme(scheme) {
    return typeof scheme === 'string' && ['http', 'https', 'ws', 'wss'].includes(scheme);
}
exports.isValidScheme = isValidScheme;
//# sourceMappingURL=guards.js.map